

































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { IOrder, IPayment } from '@resclick/data-access';
import { i18n } from '@/i18n';

@Component
export default class OrderCancellationModal extends Mixins(ModalMixin) {
  form: CrsForm<'orders', 'cancel'> = this.$crsForm('orders', 'cancel', {
    deductions: [],
  });
  order: IOrder = {} as IOrder;

  get payments() {
    return this.order.payments || [];
  }

  get deductionTypeOptions() {
    return [
      { label: i18n.t('GENERAL.AMOUNT'), value: 'AMOUNT' },
      { label: i18n.t('GENERAL.PERCENT'), value: 'PERCENT' },
    ];
  }

  @Watch('open')
  onInit(isOpen: boolean) {
    if (isOpen) {
      compass
        .do('orders', 'findOne', {
          params: { orderId: this.id },
          populate: [{ path: 'payments' }],
        })
        .then((res) => {
          this.order = res.data;
          const payments: IPayment[] = this.payments;
          this.form.fields.deductions = payments.map((payment) => {
            return {
              id: payment.id as string,
              type: 'AMOUNT',
              value: 0,
            };
          });
        });
    } else {
      this.order = {} as IOrder;
      this.form.fields.deductions = [];
    }
  }

  getReturnAmount(paymentIndex: number) {
    const payment = this.payments[paymentIndex] || { amount: 0, type: 'AMOUNT' };
    const paymentAmount = payment.amount;

    console.log(paymentIndex, this.form.fields.deductions[paymentIndex]);
    const deduction = this.form.fields.deductions[paymentIndex];

    const deductionAmount = deduction.type === 'PERCENT' ? (paymentAmount / 100) * deduction.value : deduction.value;

    return paymentAmount - deductionAmount;
  }

  // async getForm() {
  //   // return compass.do('orders', 'findOne', { params: { orderId: this.id }, populate: [{ path: 'payments' }] });
  // }
}
